var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2, _path3, _ellipse, _ellipse2, _circle13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji74(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 29,
    cy: 3,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 33,
    cy: 8,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 33,
    cy: 4,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 7,
    cy: 3,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 3,
    cy: 8,
    r: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 3,
    cy: 4,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE7B8",
    d: "M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 30.5,
    cy: 4.5,
    r: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 32,
    cy: 7,
    r: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 5.5,
    cy: 4.5,
    r: 2.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4289C1",
    cx: 4,
    cy: 7,
    r: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 6.93,
    cy: 21,
    r: 4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 28.93,
    cy: 21,
    r: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA2F47",
    d: "M27.335 23.629c-.178-.161-.444-.171-.635-.029-.039.029-3.922 2.9-8.7 2.9-4.766 0-8.662-2.871-8.7-2.9-.191-.142-.457-.13-.635.029-.177.16-.217.424-.094.628C8.7 24.472 11.788 31 18 31s9.301-6.528 9.429-6.743c.123-.205.084-.468-.094-.628z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M27.335 23.629c-.178-.161-.444-.171-.635-.029-.039.029-3.922 2.9-8.7 2.9-4.766 0-8.662-2.871-8.7-2.9-.191-.142-.457-.13-.635.029-.177.16-.217.424-.094.628C8.7 24.472 11.788 31 18 31s9.301-6.528 9.429-6.743c.123-.205.084-.468-.094-.628z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664500",
    cx: 11.5,
    cy: 11.5,
    rx: 2.5,
    ry: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664500",
    cx: 25.5,
    cy: 11.5,
    rx: 2.5,
    ry: 3.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BB1A34",
    cx: 18.5,
    cy: 19.5,
    r: 3.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji74);
export default __webpack_public_path__ + "static/media/emoji74.294250bf9a94ce2d5d4c459533652d9c.svg";
export { ForwardRef as ReactComponent };